import { Helmet } from 'react-helmet';
import Home from 'src/features/Home';
import MainLayout from 'src/layouts';
import MainContainer from "src/components/common/MainContainer";

const HomePage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
        <Home />
    </MainLayout>
  );
};

export default HomePage;
